export default "__VITE_ASSET__DdbAVhNj__"